<template>
  <div class="pl-md-3 pl-xs-1 d-flex flex-row align-center">
    <label class="avoore-checkbox path d-block mr-2" v-bind:class="{ 'theme--dark': $vuetify.theme.dark }"
      for="select-all-inbox">
      <input type="checkbox" class="d-inline-flex" v-model="selectAllInbox" id="select-all-inbox" />
      <svg viewBox="0 0 21 21">
        <path
          d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186">
        </path>
      </svg>
    </label>

    <v-toolbar-title>
      {{ heading }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" style="top: -2px" class="ml-2 red--text">{{
            filterIsOn
          }}</v-icon>
        </template>
        <span>{{ $t("tooltip.filter-is-on") }}</span>
      </v-tooltip>
    </v-toolbar-title>

    <v-dialog v-model="dialog" persistent width="600">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('pagetitle.filter data') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete data-hintposition="middle-middle" data-position="bottom-left-aligned" hide-details="true"
                  v-model="filterValue.memoType" v-bind:disabled="isUpdating" v-bind:items="memoTypeList"
                  v-bind:menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }" hide-selected deletable-chips small-chips v-bind:search-input.sync="searchInput"
                  v-on:change="searchInput = ''" chips color="blue-grey lighten-2" v-bind:label="$t('label.memo type')"
                  item-text="title" item-value="value" multiple clearable>
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" v-bind:input-value="data.selected" close @click="data.select"
                      @click:close="remove(data.item)">
                      {{ data.item.title }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content v-html="data.item.title">
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete data-hintposition="middle-middle" data-position="bottom-left-aligned" hide-details="true"
                  v-model="filterValue.dataStatus" v-bind:disabled="isUpdating" v-bind:items="memoStatusList"
                  v-bind:menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }" hide-selected deletable-chips small-chips v-bind:search-input.sync="searchInput"
                  v-on:change="searchInput = ''" chips color="blue-grey lighten-2" v-bind:label="$t('label.data status')"
                  item-text="title" item-value="value" multiple clearable>
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" v-bind:input-value="data.selected" close @click="data.select"
                      @click:close="removeStatus(data.item)">
                      {{ data.item.title }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content v-html="data.item.title">
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*{{ $t('text.by default all are checked') }}</small>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between bg-surface-variant">
          <div>
            <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
              {{ $t('button.close') }}
            </v-btn>
          </div>
          <div>
            <v-btn class="ma-1" color="blue-darken-1" variant="text" @click="resetFilter()">
              {{ $t('button.reset') }}
            </v-btn>
            <v-btn class="ma-1" color="blue-darken-1" variant="text" @click="doFilter()">
              {{ $t('button.filter') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="!enableAction" class="ml-md-4 ml-sm-0" v-bind="attrs" v-on="on" text icon
          color="blue lighten-2 ml-3" @click="menuAction('reload', 'reload')">
          <v-icon>{{ iconReload }}</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("tooltip.reload") }}</span>
    </v-tooltip>
   
   <v-menu
      v-if="$vuetify.breakpoint.smAndDown && !enableAction"
      v-model="showSearch"
      v-bind:close-on-content-click="false"
      v-bind:nudge-width="300"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          icon
          color="blue lighten-2"
          class="d-flex d-sm-none"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-col cols="12" sm="12" md="12">
          <v-text-field
            v-bind:label="$t('label.title-or-sender-name')"
            outlined
            v-model="searchQuery"
            dense
            clearable
            hide-details="true"
          ></v-text-field>
        </v-col>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="showSearch = false">{{
            $t("button.close")
          }}</v-btn>
          <v-btn color="primary" text @click="applyQuery">{{
            $t("button.search")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    
    <v-menu
      bottom
      v-if="jabatanMenuType"
      :close-on-content-click="true"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              class="ml-sm-0 spi-button"
              v-bind="attrs"
              v-on="{ ...tooltip, ...menu }"
              text
              icon
              :class="{ 'bg-spi-active': spiFilterIsActive }"
            >
              <v-icon>{{ iconNewFilter }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("tooltip.filter_pengirim") }}</span>
        </v-tooltip>
      </template>

      <v-list>
        <v-list-item
          v-for="item in filteredJabatanMenu"
          :key="item.id"
          class="cursor-pointer memo-header-menu"
          @click="doFilterJabatan(item.value)"
          :class="{
            'v-list-item--active success white--text':
              filterParams.flag === item.value,
          }"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          class="cursor-pointer memo-header-menu"
          @click="resetJabatanFilter()"
        >
          <v-list-item-title>Reset Filter</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="!enableAction" v-bind="attrs" v-on="on" text icon color="blue lighten-2 ml-3"
          @click="dialog = true">
          <v-icon>{{ iconFilter }}</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("tooltip.menu-filter") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="!$vuetify.breakpoint.smAndDown && !enableAction">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field v-on="on" v-bind="attrs" v-model="searchQuery" :label="$t('label.search')"
          :placeholder="$t('label.memo-title-or-sender')" outlined dense clearable hide-details="true"
          class="ml-2 search-input" :class="{ 'min-w-300px': searchQuery }"></v-text-field>
      </template>
      <span>{{ $t("tooltip.type-title-or-sender-name-then-enter") }}</span>
    </v-tooltip>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import {
  mdiReload,
  mdiDotsVertical,
  mdiEmailSearchOutline,
  mdiFilterMenuOutline,
  mdiEyeOutline,
  mdiEyeOffOutline,
  mdiArchiveArrowDownOutline,
  mdiTuneVariant,
  mdiIncognito,
  mdiCog,
  mdiAccountFilter,
} from "@mdi/js";
import toolbarMenu from "@/constants/toolbarmenu";

export default {
  name: "header-left",
  components: {},
  props: {
    heading: {
      type: String,
      default: "",
    },
    enableAction: {
      type: Boolean,
    },
    filterModal: {
      type: Boolean
    }
  },
  data: () => ({
    searchInput: "",
    iconReload: mdiReload,
    iconAgent: mdiIncognito,
    iconMenu: mdiDotsVertical,
    iconSearch: mdiEmailSearchOutline,
    iconFilter: mdiFilterMenuOutline,
    iconEye: mdiEyeOutline,
    iconEyeClosed: mdiEyeOffOutline,
    iconArchive: mdiArchiveArrowDownOutline,
    menus: toolbarMenu.inboxFilterMenu,
    iconFilterActive: mdiTuneVariant,
    iconGear: mdiCog,
    iconNewFilter: mdiAccountFilter,
    showSearch: false,
    searchQuery: "",
    timeout: null,
    isUpdating: false,

    memoTypeList: [
      { title: 'Memo Biasa', value: 'biasa' },
      { title: 'Memo BOM', value: 'bom' },
      { title: 'Memo Subholding', value: 'subholding' },
      { title: 'Surat X Nusantara', value: 'xnusantara' },

    ],
    memoStatusList: [
      { title: 'Belum Dibaca', value: 'unread' },
      { title: 'Belum Didisposisikan', value: 'pending' },
      { title: 'Didisposisikan', value: 'delegated' },
      { title: 'Ada Umpan Balik', value: 'has_feedback' },
      { title: 'Diarsipkan', value: 'archived' },
    ],
    filterValue: {
      memoType: [
        "biasa",
        "bom",
        "subholding",
        "xnusantara",
      ],
      dataStatus: [
        'unread',
        'pending',
        'delegated',
        'has_feedback',
        'archived',
      ],
    }
  }),
  computed: {
    ...mapState("inbox", ["filterParams", "spiFilterIsActive"]),
    ...mapState("user", ["currentUser"]),

    dialog: {
      get() {
        return this.filterModal
      },
      set(val) {
        this.$emit("filterModal", val);
      },
    },
    filterIsOn() {
      const arrType = this.filterParams.type.split(',');
      const arrStatus = this.filterParams.only.split(',');

      if ((arrType.length === this.memoTypeList.length) && (this.memoStatusList.length === arrStatus.length )) return null;
      return this.iconFilterActive;
    },
    jabatanMenuType() {
      if (!this.currentUser || !this.currentUser.nama_jabatan) return null;
      const jabatan = this.currentUser.nama_jabatan.toLowerCase();
      
      // Full menu: Direktur Utama
      if (jabatan === 'direktur utama') {
        return 'full';
      }
      
      // Partial menu: Plt. Direktur Hubungan Kelembagaan, Direktur Hubungan Kelembagaan,
      // Plt. Direktur Operasional, Direktur Operasional
      const partialMenuJabatans = [
        'plt. direktur hubungan kelembagaan',
        'direktur hubungan kelembagaan',
        'plt. direktur operasional',
        'direktur operasional'
      ];
      
      if (partialMenuJabatans.includes(jabatan)) {
        return 'partial';
      }
      
      return null;
    },
    filteredJabatanMenu() {
      const allMenus = [
        { id: 1, value: 'spi', title: 'SPI' },
        { id: 2, value: 'holding', title: 'Holding' },
        { id: 3, value: 'regional', title: 'Region Office' },
      ];
      
      if (this.jabatanMenuType === 'full') {
        return allMenus;
      } else if (this.jabatanMenuType === 'partial') {
        return allMenus.filter(item => item.id !== 1); // Hanya item 2 dan 3
      }
      return [];
    },
    selectAllInbox: {
      get() {
        return this.$store.state.inbox.selectAllInbox;
      },
      set(e) {
        this.$store.commit("inbox/SET_SELECT_ALL_INBOX", e);
      },
    },
  },
  watch: {
    searchQuery(val) {
      if (val && val.length < 3) return;

      let params = this.filterParams;

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        params.filter = val ? val : "";
        this.loadInbox(params);
      }, 1000);
    },
  },
  mounted() {
    // Initialize jabatan filter from localStorage persistence
    this.$store.dispatch("inbox/initJabatanFilter");
  },
  methods: {
    ...mapActions(["setMessageBox"]),
    ...mapActions("inbox", ["loadInbox", "doSelectAllInbox"]),
    selectAll(e) {
      this.doSelectAllInbox(e.target.checked);
    },
    applyQuery() {
      this.showSearch = false;
      if (!this.searchQuery || this.searchQuery == "") return;
      let params = this.filterParams;
      params.filter = this.searchQuery;
      this.loadInbox(params);
    },
    menuAction(command, slug) {
      this.$emit("menuAction", { command: command, slug: slug });
    },
    doFilter() {
      let params = this.filterParams;
      params.type = this.filterValue.memoType.join();
      params.only = this.filterValue.dataStatus.join();
      params.flag = '';
      this.$store.dispatch("inbox/resetJabatanFilter");
      this.loadInbox(params);
      this.timeout = setTimeout(() => {
        this.dialog = false
      }, 500);
    },
    doFilterSpi(){
      let params = this.filterParams;
      const newStatus = !this.spiFilterIsActive;
      const newFlag = newStatus ? 'spi' : '';
      this.$store.dispatch("inbox/setSpiFilterIsActive", newStatus);
      this.$store.dispatch("inbox/setJabatanFilterFlag", newFlag);
      params.flag = newFlag;
      this.loadInbox(params);
    },
    doFilterJabatan(value) {
      let params = this.filterParams;
      const isSameFilter = params.flag === value;
      
      // Toggle: jika filter yang sama diklik, matikan filter
      const newFlag = isSameFilter ? '' : value;
      const isActive = !isSameFilter;
      
      this.$store.dispatch("inbox/setSpiFilterIsActive", isActive);
      this.$store.dispatch("inbox/setJabatanFilterFlag", newFlag);
      params.flag = newFlag;
      this.loadInbox(params);
    },
    resetJabatanFilter() {
      let params = this.filterParams;
      this.$store.dispatch("inbox/resetJabatanFilter");
      params.flag = '';
      this.loadInbox(params);
    },
    resetFilter() {
      let params = this.filterParams;
      this.filterValue.memoType = [
        "biasa",
        "bom",
        "subholding",
        "xnusantara",
      ]
      this.filterValue.dataStatus = [
        'unread',
        'pending',
        'delegated',
        'has_feedback',
        'archived'
      ]
      params.type = this.filterValue.memoType.join();
      params.only = this.filterValue.dataStatus.join();
      params.flag = '';
      this.$store.dispatch("inbox/resetJabatanFilter");
      this.loadInbox(params);

      this.timeout = setTimeout(() => {
        this.dialog = false
      }, 500);
    },
    remove(item) {
      // console.log(this.filterValue.memoType)
      let index = this.filterValue.memoType.indexOf(item.value)
      if (index >= 0) this.filterValue.memoType.splice(index, 1)
    },
    removeStatus(item) {
      // console.log(item.value)
      // console.log(this.filterValue.dataStatus)
      let index = this.filterValue.dataStatus.indexOf(item.value)
      if (index >= 0) this.filterValue.dataStatus.splice(index, 1)
    },
  },
};
</script>
<style scoped> 
.spi-button{
  border-radius: 14px !important;
  height: 40px !important;
  width: 40px !important;
}
.spi-button:not(.bg-spi-active) {
  border: 1px solid #64B5F6 !important;
  background-color: transparent !important;
}
.spi-button span {
  font-size: 18px;
}
.spi-button:not(.bg-spi-active) span {
  color: #35c7df !important;
}
.spi-button:hover:not(.bg-spi-active) {
  background-color: rgba(100, 181, 246, 0.1) !important;
}
.spi-button:hover:not(.bg-spi-active) span {
  color: #64B5F6 !important;
}
.bg-spi-active {
  background-color: #35c7df !important;
  border: 1px solid #35c7df !important;
  position: relative;
}
.bg-spi-active span {
  color: #ffffff !important;
}
.bg-spi-active::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(100, 181, 246, 0.5);
  transform: translate(-50%, -50%) scale(1);
  animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
  pointer-events: none;
  z-index: -1;
}
@keyframes ping {
  75%, 100% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0;
  }
}
</style>